module.exports = __webpack_public_path__ + "static/media/table_background_high_large.d74ac7c5.jpg";